import produce from "immer";
import { ContextParam } from "interfaces/Home";
import { ContextTypes } from "constant";
import { ActionTyped } from "./IAction";

/**
 * différent paramètre du reducer de context
 */
export interface ContextState {
  selected: string;
  contexts: Array<ContextParam>;
}

export type SelectContextAction = ActionTyped<ContextTypes.SELECT_CONTEXT, { selected: string }>;

export type FetchContextSuccess = ActionTyped<
  ContextTypes.FETCH_CONTEXT_SUCCESS,
  { contexts: ContextParam[] }
>;

type Action = SelectContextAction | FetchContextSuccess;

/**
 * Reducer de gestion des contextes dans l'application
 *
 * @export
 * @param {ContextState} [state={ selected: "", contexts: [] }] state redux
 * @param {Action} action action possible
 * @returns {ContextState} state redux
 */
export default function context(
  state: ContextState = { selected: "", contexts: [] },
  action: Action
): ContextState {
  switch (action.type) {
    case ContextTypes.SELECT_CONTEXT:
      const { selected } = action.payload;
      return produce(state, draft => {
        draft.selected = selected != null ? selected : "";
      });

    case ContextTypes.FETCH_CONTEXT_SUCCESS:
      const { contexts } = action.payload;
      return produce(state, draft => {
        draft.contexts = contexts ? contexts : [];
      });

    default:
      return state;
  }
}
